import { accessToken } from './accessToken';
import type { AccessToken } from './tokenHandlingSlice';

export const prepareHeaders = (headers: Headers) => {
    const token = accessToken.selectAccessToken() as AccessToken;
    if (token) {
        headers.set('authorization', `Bearer ${token}`);
        headers.set('Content-Type', 'application/json');
    }
    return headers;
};
